import React from "react";
import LoginCreative from "./Components/Login/LoginCreative";
import ResetCreative from "./Components/Login/ResetCreative";
import { Route, Routes } from "react-router-dom";
import Home from "./Components/Home/Home";


import StudentContent from "./Components/Student/StudentContent"
import State from "./Components/State/State";
import EditState from "./Components/State/EditState";
import StateList from "./Components/State/StateList";


import Course from "./Components/Course/Course";
import CourseList from "./Components/Course/CourseList";
import EditCourse from "./Components/Course/EditCourse";
import Semester from "./Components/Semester/Semester";
import SemesterList from "./Components/Semester/SemesterList";
import EditSemester from "./Components/Semester/EditSemester";
import Subject from "./Components/Subject/Subject";
import SubjectList from "./Components/Subject/SubjectList";
import EditSubject from "./Components/Subject/EditSubject";
import Chapter from "./Components/Chapter/Chapter";
import ChapterList from "./Components/Chapter/ChapterList";
import EditChapter from "./Components/Chapter/EditChapter";
import TopicList from "./Components/Topic/TopicList";
import EditTopic from "./Components/Topic/EditTopic";
import Content from "./Components/Content/Content";
import ContentList from "./Components/Content/ContentList";
import EditContent from "./Components/Content/EditContent";
import Package from "./Components/Package/Package";
import PackageList from "./Components/Package/PackageList";
import EditPackage from "./Components/Package/EditPackage";
import Student from "./Components/Student/StudentRenewal";
import StudentList from "./Components/Student/StudentList";
import ViewContent from "./Components/Content/ViewContent";
import EditNotes from "./Components/Content/EditNotes";
import EditPdf from "./Components/Content/EditPdf";
import EditVideo from "./Components/Content/EditVideo";
import StudentRenewal from "./Components/Student/StudentRenewal";
import RenewalList from "./Components/Student/RenewalList";
import Library from "./Components/Student/Library";
import StudentRenewalContent from "./Components/Student/StudentRenewalContent";
import NotFound from "./Components/Home/NotFound";


const App = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<LoginCreative />} />
        <Route path="/reset-password" element={<ResetCreative />} />
        <Route path="/home" element={<Home />} />
        <Route path="*" element={<NotFound/>} />
      

        {/* State */}
        <Route path="/master/add-state" element={<State />} />
        <Route path="/master/state-list" element={<StateList />} />
        <Route path="/master/edit-state/:id" element={<EditState />} />



    

        {/* Course */}
        <Route path="/master/add-course" element={<Course />} />
        <Route path="/master/course-list" element={<CourseList />} />
        <Route path="/master/edit-course/:id" element={<EditCourse />} />

        {/* Semester */}
        <Route path="/master/add-semester" element={<Semester />} />
        <Route path="/master/semester-list" element={<SemesterList />} />
        <Route path="/master/edit-semester/:id" element={<EditSemester />} />

        {/* Subject */}
        <Route path="/master/add-subject" element={<Subject />} />
        <Route path="/master/subject-list" element={<SubjectList />} />
        <Route path="/master/edit-subject/:id" element={<EditSubject />} />

        {/* Chapter */}
        <Route path="/master/add-chapter" element={<Chapter />} />
        <Route path="/master/chapter-list" element={<ChapterList />} />
        <Route path="/master/edit-chapter/:id" element={<EditChapter />} />

        {/* Topic */}
      
        {/* <Route path="/master/topic-list" element={<TopicList />} /> */}
        <Route path="/master/edit-topic/:id" element={<EditTopic />} />

        {/* Content */}
        <Route path="/master/add-topic" element={<Content />} />
        <Route path="/master/topic-list" element={<ContentList />} />
       
        <Route path="/student/edit-pdf/:id" element={<EditPdf/>} />
        <Route path="/student/edit-notes/:id" element={<EditNotes />} />
        <Route path="/student/edit-video/:id" element={<EditVideo />} />



        {/* Package */}
        <Route path="/master/add-package" element={<Package />} />
        <Route path="/master/package-list" element={<PackageList />} />
        <Route path="/master/edit-package/:id" element={<EditPackage />} />

        {/* Student */}
        <Route path="/master/student-renewal-list" element={<RenewalList />} />
        <Route path="/master/student-list" element={<StudentList />} />

        <Route path="/student/view/:id" element={<StudentContent />} />
        <Route path="/student/renewalview/:id" element={<StudentRenewalContent />} />

         <Route path="/student/library/:id" element={<Library />} />
        <Route path="/content/view/:id" element={<ViewContent />} />
      </Routes>
    </>
  );
};

export default App;
